(function () {
  function bindSearchForms(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-sbs-search-form]:not([data-sbs-search-bound])').forEach(function (form) {
      form.setAttribute('data-sbs-search-bound', 'true');

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var searchUrl = form.getAttribute('data-search-url');
        var queryInput = form.querySelector('input[name="q"]');
        if (!searchUrl || !queryInput) return;

        var params = new URLSearchParams();
        var query = queryInput.value.trim();

        if (query) params.set('q', query);

        params.set('type', 'article');
        params.set('view', 'blog-articles');

        form.querySelectorAll('input[type="hidden"][name]').forEach(function (input) {
          if (input.value) params.set(input.name, input.value);
        });

        var destination = params.toString() ? searchUrl + '?' + params.toString() : searchUrl;
        window.location.assign(destination);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindSearchForms(document);
    });
  } else {
    bindSearchForms(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (root) bindSearchForms(root);
  });
})();
